import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import { IGlobalContext } from "../globalContext/globalContext.interfaces";
import { RootState } from '../store';

const initialState: IGlobalContext = {
	originUrl: undefined
}

export const GlobalStateSlice = createSlice({
	name: 'GlobalContext',
	initialState,
	reducers: {
		setOriginUrl: (state, action: PayloadAction<string>) => {
			state.originUrl = action.payload;
		},
	}
})

export const selectOriginUrl = (state: RootState) => state.GlobalState.originUrl
export const { setOriginUrl } = GlobalStateSlice.actions;